export const getLocalStorageItem = (key: string): any => {
  const item = localStorage.getItem(key)
  try {
    return JSON.parse(item as string)
  } catch {
    return item
  }
}

export const setLocalStorageItem = (key: string, data: unknown): void => {
  localStorage.setItem(key, JSON.stringify(data))
}

export const deleteLocalStorageItem = (key: string): void => {
  localStorage.removeItem(key)
}

export const deleteLocalStorageItems = (keys: string[]): void => {
  keys.forEach(deleteLocalStorageItem)
}

export const clearLocalStorage = (): void => {
  localStorage.clear()
}

export const getSessionStorageItem = (
  key: string,
): string | null | { [key: string]: string } => {
  const item = sessionStorage.getItem(key)
  try {
    return JSON.parse(item as string)
  } catch {
    return item
  }
}

export const updateSessionStorageItem = (key: string, data: unknown): void => {
  sessionStorage.setItem(key, JSON.stringify(data))
}

export const setSessionStorageItem = (key: string, data: unknown): void => {
  if (!getSessionStorageItem(key)) {
    updateSessionStorageItem(key, data)
  }
}

export const deleteSessionStorageItem = (key: string): void => {
  sessionStorage.removeItem(key)
}

export const clearSessionStorage = (): void => {
  sessionStorage.clear()
}
